module.exports = __webpack_public_path__ + "img/sz.sz468d80d.svg";